module.exports = __webpack_public_path__ + "img/downsort1.1ff98686.png";